import { configureStore } from "@reduxjs/toolkit";
import { agoraReducer } from "./agora.reducer";

export const store = configureStore({
    reducer: agoraReducer
});